import React, { Component } from 'react';
import { Button, Checkbox } from "react-bootstrap";
import { to } from "../../Utils";

import CreateConversionForm from "./components/CreateConversionForm";
import conversionsCutoff from "../../services/API/components/peerclick/conversions-cutoff";
import ConversionsTable from "./components/ConversionTable";
import countriesObj from "../../data/countries";
import SelectWrap from "../../components/SelectWrap";
import SyncMessage from "../../components/SyncMessage";
import FieldGroup from "../../components/FieldGroup";
import Container from "../../components/Container";
import Heading from '../../components/Heading';
import API from "../../services/API";

import './styles.css';

class PeerclickConversionsCutoff extends Component {
    constructor(props) {
        super(props);

        this.state = {
            conversions: [],
            affids: [],
            subids: [],
            dailyOptimization: 0,
            selectedAffid: null,
            selectedSubid: null,
            selectedCountry: null,
            selectedDate: '',
            showOverlay: false,
            isLoading: false,
            syncData: null
        };


        this.handleSearch = this.handleSearch.bind(this);
        this.onRemoveClick = this.onRemoveClick.bind(this);
        this.onCreate = this.onCreate.bind(this);
        this.onAffidSelect = this.onAffidSelect.bind(this);
    }

    componentWillMount() {
        (async () => {
            this.setState({ isLoading: true })

            const [error, affids] = await to(conversionsCutoff.affids());

            if(error) {
                return alert('Error happened while requesting data.');
            }

            this.setState({ affids, isLoading: false });
            this.forceUpdate();
        })();
    }

    async onRemoveClick(id) {
        if(!window.confirm(`Are you sure you want to delete conversion with id ${id}?`)) {
            return;
        }

        this.setState({ isLoading: true })

        const [err, data] = await to(conversionsCutoff.delete(id));

        if(err) {
            return alert("Error while deleting data, reload the page.")
        }

        if(data.success) {
            this.setState({ conversions: this.state.conversions.filter(x => x.id !== id), isLoading: false });
        }
    }

    async onCreate(data) {
        this.setState({ isLoading: true });

        const [err, response] = await to(conversionsCutoff.create(data));

        if(err) console.log(err)

        if(response.success) {
            this.setState({ showOverlay: false, isLoading: false });
        }
    }

    handleSync() {
        this.setState({ isLoading: true });

        API.Sync(['app'], 'peerclickConversionCutoff', 8081)
            .then((res) => {
                this.setState({ isLoading: false, syncData: { res } });
            })
            .catch(err => {
                this.setState({ isLoading: false, syncData: { reqErr: err } });
            });
    }

    async handleSearch() {
        this.setState({ isLoading: true })

        const [ error, data ] = await to(conversionsCutoff.get({ affid: this.state.selectedAffid, subid: this.state.selectedSubid, country: this.state.selectedCountry, dailyOpt: this.state.dailyOptimization, date: this.state.selectedDate }));

        if(error) {
            return alert('Error happened while requesting data.');
        }

        this.setState({ conversions: data, isLoading: false  });
    }

    async onCutoffUpdate(id) {
        const cutoff = prompt("Enter new cutoff: ");
        if(!cutoff || isNaN(cutoff)) return alert("Please enter correct number.");

        this.setState({ isLoading: true })

        const [error, data] = await to(conversionsCutoff.update(id, { cutoff }));
        if(error) return console.log(error);

        // Update table with new rows
        await this.handleSearch();
    }

    async onAffidSelect(e) {
        this.setState({ isLoading: true, selectedAffid: e.target.value })

        if (e.target.value.length) {
            const [error, subids] = await to(conversionsCutoff.subids({ affid: e.target.value }))
            if (error) console.log(error);

            this.setState({ isLoading: false, subids })
        } else {
            this.setState({ isLoading: false, selectedSubid: null, subids: [] })
        }
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="Bad source blocker"/>

                <div className="row">
                    <div className="col-lg-12" style={{margin: '0 15px 15px 0'}}>
                        <div className="pull-right">
                            <button onClick={this.handleSync.bind(this)} className="btn btn-info" style={{marginRight: '0.5em'}}>Sync</button>
                            <button onClick={() => this.setState({ showOverlay: true })} className="btn btn-success">Create</button>
                        </div>
                    </div>
                </div>

                <SyncMessage {...this.state.syncData} />

                <div style={{ marginBottom: '15px' }}>
                    <SelectWrap
                        values={this.state.affids}
                        value={this.state.selectedAffid}
                        label="Affiliate ID:"
                        name="affid"
                        onChange={this.onAffidSelect}
                        multi
                        required
                    />

                    <SelectWrap
                        values={this.state.subids}
                        value={this.state.selectedSubid}
                        label="Subid:"
                        name="subid"
                        onChange={(e)=> this.setState({ selectedSubid: e.target.value })}
                        disabled={!this.state.selectedAffid || !this.state.selectedAffid.length}
                        multi
                        required
                    />

                    <SelectWrap
                        values={countriesObj}
                        value={this.state.selectedCountry}
                        label="Country:"
                        name="country"
                        onChange={(e)=> this.setState({ selectedCountry: e.target.value })}
                        multi
                        required
                    />

                    <FieldGroup
                        type="date"
                        name="Select Date"
                        label="Date:"
                        onChange={(e)=> this.setState({ selectedDate: e.target.value })}
                        value={this.state.selectedDate}
                    />

                    <Checkbox onChange={(e) => this.setState({ dailyOptimization: Number(e.target.checked) })} name="dailyOpt">Daily Optimization</Checkbox>


                    <Button className="btn btn-success" onClick={this.handleSearch.bind(this)}>
                        Search
                    </Button>
                    {/* Filters Group */}
                </div>

                {!!this.state.conversions.length && (
                    <ConversionsTable conversions={this.state.conversions} onCutoffUpdate={this.onCutoffUpdate.bind(this)} onRemoveClick={this.onRemoveClick.bind(this)}/>
                )}

                {!this.state.conversions.length && (
                    <div className="alert alert-info">
                        No conversions found.
                    </div>
                )}

                {this.state.showOverlay && <CreateConversionForm onCreate={this.onCreate.bind(this)} onHide={() => this.setState({ showOverlay: false })}/>}
            </Container>
        )
    }
}

export default PeerclickConversionsCutoff;



// WEBPACK FOOTER //
// ./src/scenes/PeerclickConversionsCutoff/index.js